import classNames from 'classnames';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: inline-block;
  width: 100%;
  margin: 5px 0;
  .skeleton-box{
    height: 23px;
    width: 100%;
    border-radius: 25px;
    margin-right: 5px;
    &.marginTopBottom {
      margin-top: 11.3px;
      margin-bottom: 11.3px;
    }
  }
`;

type Props = {
  marginTopBottom?: boolean,
} & typeof defaultProps;

const defaultProps = {
  marginTopBottom: false,
};

const ApproachTipSkeleton = function ApproachTipSkeleton(props: Props) {
  const { marginTopBottom } = props;
  return (
    <Wrapper>
      <span className={classNames('skeleton-box', { marginTopBottom })} />
    </Wrapper>
  );
};

ApproachTipSkeleton.defaultProps = defaultProps;
export default ApproachTipSkeleton;
